import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getGoogleFlowDomainListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.CMS_GOOGLE_FLOW,
        params: params,
    });
};


export const postGoogleFlowRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.CMS_GOOGLE_FLOW,
        data: data,
    });
};
  